// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer___Blrm_","table":"table___DKySs"};